import PrimeCarouselPagination from './PrimeCarouselPagination'

export default PrimeCarouselPagination.extend({
    name: 'PrimeCarouselNumbersPagination',
    methods: {
        genItems(h) {
            return h('li', [
                h('span', this.value + 1),
                h('span', '/'),
                h('span', this.carouselItems.length)
            ]);
        },
    },
});
